import {
    CHANGE_SELECTED_DOCUMENT,
    TASK_DETAILS_LOADED,
    TASK_DETAILS_LOADING,
    HAS_EDITED_DOCUMENT,
    CHANGE_ROTATION,
    UPDATE_DOCUMENT_VERSION,
    WORKFLOW_DETAILS_LOADED,
    WORKFLOW_HISTORY_LOADED,
    WORKFLOW_DETAILS_LOADING_ERROR,
    TASK_DOCUMENT_DATA_LOADED,
    CHANGE_ZOOM_PERCENTAGE,
    WORKFLOW_DETAILS_LOADING,
    TASK_DOCUMENT_DATA_LOADING,
    TASK_COMMENTS_LOADED,
    TASK_COMMENTS_LOADING,
    CHANGE_IMAGE_ZOOM_PERCENTAGE,
    CACHE_ATTACHMENTS_IMAGES_URLS,
    IFRAME_HAS_CHANGES,
    IFRAME_HAS_VBNXT_SAVE_DISCARD_FLAG,
    DOCUMENT_PREVIEW_DETACH,
    DOCUMENT_PREVIEW_REATTACH,
    DOCUMENT_PREVIEW_STATUS_CHANGED,
    DOCUMENT_PREVIEW_TITLE_CHANGED,
    EDITOR_DETACH,
    EDITOR_REATTACH,
    EDITOR_TITLE_CHANGED,
    TASK_DETAILS_CLOSING,
    DRAFT_COMMENT_LOADED,
    DRAFT_COMMENT_SAVE_STATUS_CHANGED,
    TASK_DETAILS_LOADING_ERROR,
    TASK_DETAILS_REDIRECTED,
    DRAFT_COMMENT_LOAD_ERROR, TASK_DETAILS_LOADED_BY_UID,
} from "../store/actionTypes";

import {
    LOADING_STATUS,
    APPROVAL,
    IMAGE_MIME_TYPE,
    COMMENT_SAVING_STATUS,
    DOCUMENT_PREVIEW_STATUS, USER_SCOPES,
} from "utils/constants";
import _ from "lodash";
import {createSelector} from 'reselect';
import MIMEType from "whatwg-mimetype";
import {launchDarkly} from "utils/launchDarkly";

const normalizeAttachmentImageURL = (imageURL) => {
    if (typeof imageURL === "string") {
        return {
            url: imageURL,
            height: null,
            width: null,
        };
    }
    if (!imageURL || typeof imageURL !== "object") {
        return {
            url: null,
            height: null,
            width: null,
        };
    }
    return {
        url: typeof imageURL.url === "string" ? imageURL.url : null,
        height: Number.isFinite(imageURL.height) ? imageURL.height : null,
        width: Number.isFinite(imageURL.width) ? imageURL.width : null,
    };
};


export const DEFAULT_STATE = {
    zoomPercentage: 100,
    imageZoomPercentage: 100,
    details: {},
    activeTask: null,
    redirectedTask: null,
    attachments: null,
    permissions: [],
    documentPreviewDetach: {
        title: null,
        isDetached: false,
        status: DOCUMENT_PREVIEW_STATUS.WAITING,

    },
    editorDetach: {
        title: null,
        isDetached: false,
    },
    loadingStatus: undefined,
    selectedDocument: {
        index: 0
    },
    editedDocument: false,
    rotation: 0,
    workflow: {
        details: null,
        history: null,
        loading: null
    },
    documentData: null,
    documentDataLoadingStatus: null,
    draftComments: {
        comments: [],
        draftComment: {
            text: null,
            status: null
        },
        loading: null,
        savingStatus: COMMENT_SAVING_STATUS.IDLE
    },
    integrationIframe: {
        hasUnsavedChanges: false,
        hasVBNXTSaveDiscardFlag: false
    }
};

export default function myTaskDetailsReducer(state = DEFAULT_STATE, action) {
    let partialState;

    switch (action.type) {
        case CHANGE_ZOOM_PERCENTAGE:
            partialState = _.cloneDeep(state);
            partialState.zoomPercentage = action.data;
            return Object.assign({}, state, partialState);

        case CHANGE_IMAGE_ZOOM_PERCENTAGE:
            partialState = _.cloneDeep(state);
            partialState.imageZoomPercentage = action.data;
            return Object.assign({}, state, partialState);

        case TASK_DETAILS_LOADING:
            partialState = _.cloneDeep(state);
            partialState.redirectedTask = null;
            partialState.loadingStatus = LOADING_STATUS.LOADING;
            partialState.attachments = null;
            partialState.selectedDocument = {index: 0};
            partialState.permissions = [];
            partialState.activeTask = null;
            partialState.integrationIframe = _.cloneDeep(DEFAULT_STATE.integrationIframe);
            return Object.assign({}, state, partialState);

        case TASK_DETAILS_LOADED:
            partialState = _.cloneDeep(state);
            //reset the flag for any new task loaded
            if (partialState.details?.key !== action.data.taskDetails?.key)
                partialState.editedDocument = false;
            partialState.attachments = action.data.attachments;
            partialState.loadingStatus = LOADING_STATUS.DONE;
            // consumers read straight off details, so keep it an object even for a payload that lost its task (AC-12773)
            partialState.details = action.data.taskDetails ?? {};
            partialState.permissions = action.data.permissions ? action.data.permissions : [];
            partialState.rotation = 0;
            return Object.assign({}, state, partialState);

        case TASK_DETAILS_LOADED_BY_UID:
            partialState = _.cloneDeep(state);
            //reset the flag for any new task loaded
            if (partialState.details?.key !== action.data.taskDetails?.key)
                partialState.editedDocument = false;
            partialState.attachments = action.data.attachments;
            partialState.loadingStatus = LOADING_STATUS.DONE;
            // consumers read straight off details, so keep it an object even for a payload that lost its task (AC-12773)
            partialState.details = action.data.taskDetails ?? {};
            partialState.permissions = action.data.permissions ? action.data.permissions : [];
            partialState.activeTask = action.data.task;
            partialState.rotation = 0;
            return Object.assign({}, state, partialState);

        case TASK_DETAILS_LOADING_ERROR:
            partialState = _.cloneDeep(state);
            // without this the status stays LOADING, which leaves the subnavbar actions disabled for good (AC-12773)
            partialState.loadingStatus = LOADING_STATUS.ERROR;
            partialState.details = {};
            partialState.attachments = null;
            partialState.permissions = [];
            return {...state, ...partialState};

        case TASK_DETAILS_REDIRECTED:
            partialState = _.cloneDeep(state);
            partialState.redirectedTask = action.data;
            return Object.assign({}, state, partialState);

        case TASK_DETAILS_CLOSING:
            partialState = _.cloneDeep(state);
            partialState.redirectedTask = null;
            partialState.attachments = null;
            partialState.selectedDocument = {index: 0};
            partialState.integrationIframe = _.cloneDeep(DEFAULT_STATE.integrationIframe);
            partialState.draftComments.comments = [];
            partialState.draftComments.draftComment = {
                text: null,
                status: null
            };
            partialState.permissions = [];
            return Object.assign({}, state, partialState);

        case WORKFLOW_DETAILS_LOADING:
            partialState = _.cloneDeep(state);
            partialState.workflow.loading = true;
            return Object.assign({}, state, partialState);

        case WORKFLOW_DETAILS_LOADED:
            partialState = _.cloneDeep(state);
            partialState.workflow.details = action.data;
            partialState.workflow.loading = false;
            return Object.assign({}, state, partialState);

        case WORKFLOW_HISTORY_LOADED:
            partialState = _.cloneDeep(state);
            partialState.workflow.history = action.data;
            return Object.assign({}, state, partialState);

        case WORKFLOW_DETAILS_LOADING_ERROR:
            partialState = _.cloneDeep(state);
            partialState.workflow.details = {};
            partialState.workflow.history = {};
            partialState.workflow.loading = false;
            return Object.assign({}, state, partialState);

        case CHANGE_SELECTED_DOCUMENT: {
            let selectedObj = {index: 0};
            partialState = _.cloneDeep(state);
            if (Array.isArray(partialState.attachments?.attachments) && action.index >= 0 && action.index < partialState.attachments.attachments.length) {
                selectedObj = partialState.attachments?.attachments[action.index] || {index: 0};
                selectedObj.index = action.index;
            }
            partialState.selectedDocument = selectedObj;
            partialState.imageZoomPercentage = 100;
            return Object.assign({}, state, partialState);
        }
        case HAS_EDITED_DOCUMENT:
            partialState = _.cloneDeep(state);
            partialState.editedDocument = action.data;
            return Object.assign({}, state, partialState);

        case CHANGE_ROTATION:
            partialState = _.cloneDeep(state);
            partialState.rotation = action.data;
            return Object.assign({}, state, partialState);

        case UPDATE_DOCUMENT_VERSION:
            partialState = _.cloneDeep(state);
            partialState.details.documentVersion = action.data;
            if (partialState.taskDetails)
                partialState.taskDetails.documentVersion = action.data;
            return Object.assign({}, state, partialState);

        case TASK_DOCUMENT_DATA_LOADING:
            partialState = _.cloneDeep(state);
            partialState.documentDataLoadingStatus = true;
            return Object.assign({}, state, partialState);

        case TASK_DOCUMENT_DATA_LOADED:
            partialState = _.cloneDeep(state);
            partialState.documentData = action.data;
            partialState.documentDataLoadingStatus = false;
            return Object.assign({}, state, partialState);

        case DRAFT_COMMENT_LOADED:
            partialState = _.cloneDeep(state);
            partialState.draftComments.draftComment.text = action.data.text;
            partialState.draftComments.draftComment.status = LOADING_STATUS.DONE;
            return Object.assign({}, state, partialState);

        case DRAFT_COMMENT_LOAD_ERROR:
            partialState = _.cloneDeep(state);
            partialState.draftComments.draftComment.text = null;
            partialState.draftComments.draftComment.status = LOADING_STATUS.ERROR;
            return Object.assign({}, state, partialState);

        case DRAFT_COMMENT_SAVE_STATUS_CHANGED:
            partialState = _.cloneDeep(state);
            partialState.draftComments.savingStatus = action.data;
            return Object.assign({}, state, partialState);

        case TASK_COMMENTS_LOADING:
            partialState = _.cloneDeep(state);
            partialState.draftComments.loading = true;
            return Object.assign({}, state, partialState);

        case TASK_COMMENTS_LOADED:
            partialState = _.cloneDeep(state);
            partialState.draftComments.comments = action.data;
            partialState.draftComments.loading = false;
            return Object.assign({}, state, partialState);


        case CACHE_ATTACHMENTS_IMAGES_URLS:
            partialState = _.cloneDeep(state);
            if (partialState.attachments?.attachments) {
                let foundAttachment = _.findIndex(partialState.attachments.attachments, ['id', action.data.attachmentIndex]);

                if (foundAttachment !== -1 && typeof action.data?.imageIndex !== "undefined") {
                    const attachment = partialState.attachments.attachments[foundAttachment];
                    const {url, height, width} = normalizeAttachmentImageURL(action.data?.imageURL);

                    attachment.dsURL ??= {};
                    attachment.imageHeights ??= {};
                    attachment.imageWidths ??= {};

                    attachment.dsURL[action.data.imageIndex] = url;
                    attachment.imageHeights[action.data.imageIndex] = height;
                    attachment.imageWidths[action.data.imageIndex] = width;
                }
            }
            return Object.assign({}, state, partialState);

        case DOCUMENT_PREVIEW_DETACH:
            partialState = _.cloneDeep(state);
            partialState.documentPreviewDetach.isDetached = true;
            return Object.assign({}, state, partialState);

        case DOCUMENT_PREVIEW_REATTACH:
            partialState = _.cloneDeep(state);
            partialState.documentPreviewDetach.isDetached = false;
            return Object.assign({}, state, partialState);

        case DOCUMENT_PREVIEW_TITLE_CHANGED:
            partialState = _.cloneDeep(state);
            partialState.documentPreviewDetach.title = action.data;
            return Object.assign({}, state, partialState);

        case DOCUMENT_PREVIEW_STATUS_CHANGED:
            partialState = _.cloneDeep(state);
            partialState.documentPreviewDetach.status = action.data;
            return Object.assign({}, state, partialState);

        case EDITOR_DETACH:
            partialState = _.cloneDeep(state);
            partialState.editorDetach.isDetached = true;
            return Object.assign({}, state, partialState);

        case EDITOR_REATTACH:
            partialState = _.cloneDeep(state);
            partialState.editorDetach.isDetached = false;
            return Object.assign({}, state, partialState);

        case EDITOR_TITLE_CHANGED:
            partialState = _.cloneDeep(state);
            partialState.editorDetach.title = action.data;
            return Object.assign({}, state, partialState);

        case IFRAME_HAS_CHANGES:
            partialState = _.cloneDeep(state);
            partialState.integrationIframe.hasUnsavedChanges = action.data;
            return Object.assign({}, state, partialState);

        case IFRAME_HAS_VBNXT_SAVE_DISCARD_FLAG:
            partialState = _.cloneDeep(state);
            partialState.integrationIframe.hasVBNXTSaveDiscardFlag = action.data;
            return Object.assign({}, state, partialState);

        default:
            return state;
    }
}


export const getImagesForRender = createSelector(
    [getAttachments], (attachmentsList) => {
        let imageCollection = {};

        if (!attachmentsList)
            return imageCollection;

        attachmentsList.forEach(attachment => {
            if (attachment.mimeType && attachment.mimeType.includes(IMAGE_MIME_TYPE)) {
                let images = processDSImages(attachment);
                imageCollection[attachment.id] = images;
            }
        });

        return imageCollection;

    }
);


export const getTaskAttachmentsForRender = createSelector(
    [getAttachments], (attachmentsList) => {
        let attachmentCollection = [];

        if (!attachmentsList)
            return attachmentCollection;


        attachmentCollection = attachmentsList.map(attachment => {

                const collection = {
                    id: attachment.id,
                    attachmentIds: attachment.attachmentIds || [],
                    deleteUrlTemplate: attachment.deletepageurltemplate,
                    mimeType: attachment.mimeType ? MIMEType.parse(attachment.mimeType)?.essence : null,
                    information: attachment.information || null,
                };

                if (attachment.mimeType && attachment.mimeType.includes(IMAGE_MIME_TYPE)) {
                    collection.images = processImages(attachment);
                }

                return collection;
            }
        );
        return attachmentCollection;
    }
);

function processDSImages(attachment) {
    let images = [];
    let numberOfPages;
    numberOfPages = attachment.attachmentIds?.length || 0;


    _.times(numberOfPages, (index) => {
        let imageObj = {};
        imageObj.pageId = index + 1;
        imageObj.dsURL = attachment.dsURL ? attachment.dsURL[index + 1] || "" : "";
        imageObj.height = attachment.imageHeights ? attachment.imageHeights[index + 1] || null : null;
        imageObj.width = attachment.imageWidths ? attachment.imageWidths[index + 1] || null : null;

        images.push(imageObj);
    });

    return images;
}

function processImages(attachment) {
    let images = [];
    let numberOfPages;
    numberOfPages = attachment.attachmentIds?.length || 0;

    _.times(numberOfPages, (index) => {
        let imageObj = {};
        imageObj.pageId = index + 1;
        imageObj.url = "";
        images.push(imageObj);
    });

    return images;
}

function getComments(commentsAndEvents) {
    return _.filter(commentsAndEvents, comment => comment.content !== '');
}


export function getAttachments(state) {
    return state.attachments ? state.attachments.attachments : null;
}

export function getAttachmentsDownloadLinks(state) {
    let response = {
        downloadPDFUrl: '',
        downloadZIPUrl: '',
        downloadZIPCallbackUrl: null,
        downloadPDFCallbackUrl: null,
        attachmentService: ''
    }
    if (!state.attachments || state.attachments.length === 0)
        return response;

    response.attachmentService = state.attachments.attachmentCollectionValues?.attachmentService;
    response.downloadZIPUrl = state.details?.attachmentCollection?.downloadZIPUrl;
    response.downloadPDFUrl = state.details?.attachmentCollection?.downloadPDFUrl;
    response.downloadZIPCallbackUrl = state.details?.attachmentCollection?.downloadZIPCallbackUrl;
    response.downloadPDFCallbackUrl = state.details?.attachmentCollection?.downloadPDFCallbackUrl;

    return response;
}

export function getActiveTask(state) {
    return state.activeTask;
}

export function getRedirectedTask(state) {
    return state.redirectedTask;
}

export function getTaskDetails(state) {
    return state.details;
}

export function getDetails(state) {
    return state.details ? state.details : undefined;
}

export function getZoomPercentage(state) {
    return state.zoomPercentage;
}

export function getImageZoomPercentage(state) {
    return state.imageZoomPercentage;
}

export function getSelectedDocument(state) {
    return state.selectedDocument;
}

export function getDetailsLoadingStatus(state) {
    return state.loadingStatus;
}

export function getDocumentEditedFlag(state) {
    return state.editedDocument;
}

export function getDocumentRotation(state) {
    return state.rotation;
}

export function getTaskWorkflowDetails(state) {
    return state.workflow.details;
}

export function getWorkflowDetailsLoadingStatus(state) {
    return state.workflow.loading;
}

export function getTaskWorkflowHistory(state) {
    return state.workflow.history;
}

export function getTaskDocumentData(state) {
    return state.documentData;
}

export function getTaskDocumentDataLoadingStatus(state) {
    return state.documentDataLoadingStatus;
}

export function getTaskDraftComments(state) {
    return getComments(state.draftComments.comments);
}

export function getTaskDraftCommentsLoadingStatus(state) {
    return state.draftComments.loading;
}

export function getTaskDraftCommentsSavingStatus(state) {
    return state.draftComments.savingStatus;
}

export function getTaskDraftCommentText(state) {
    return state.draftComments.draftComment.text;
}

export function getTaskDraftCommentStatus(state) {
    return state.draftComments.draftComment.status;
}

export function getTaskDraftCommentsCount(state) {
    return getComments(state.draftComments.comments).length;
}

export function getAllowExtraComments(state) {
    return state.details?.taskPermission?.allowExtraComments || state.details?.allowExtraComments;
}

export function getIsTaskDetailsLocked(state) {
    return state.integrationIframe.hasUnsavedChanges
}

export function getIframeHasUnsavedChanges(state) {
    return state.integrationIframe.hasUnsavedChanges;
}

export function getVBNXTSaveDiscardFlag(state) {
    return state.integrationIframe.hasVBNXTSaveDiscardFlag;
}

export function isDocumentPreviewDetached(state) {
    return state.documentPreviewDetach?.isDetached;
}

export function getDocumentPreviewTitle(state) {
    return state.documentPreviewDetach?.title;
}

export function getDocumentPreviewStatus(state) {
    return state.documentPreviewDetach?.status;
}

export function isEditorDetached(state) {
    return state.editorDetach?.isDetached;
}

export function getEditorTitle(state) {
    return state.editorDetach?.title;
}

export function getTaskPermissions(state) {
    return state.permissions;
}

export function canAddProcessComments(state) {
    return state.permissions.includes(USER_SCOPES.PROCESS_COMMENT);
}

export function canAddDocumentComments(state) {
    return state.permissions.includes(USER_SCOPES.DOCUMENT_COMMENT);
}
